import React from "react";
import PointOfSaleCore from "../../Core/index";
import RestaurantPreorder from "./Preorder";

const Preorder = () => {
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController);
  const tillLayout = parseInt(tillaccess?.layout === null || undefined ? 1 : tillaccess?.layout);
  return tillaccess.pos === "Y" ? <PointOfSaleCore component={RestaurantPreorder} /> : <h1>Access Denied</h1>;
};

export default Preorder;
